import React from 'react'

export default ()=>{
    return(
        <style>
        {`
        .color-section8 {
            display: flex;
            justify-content: space-around;
        }
        .free {
            margin-top: 4%;
            padding-top: 3%;
        }
        .background-section8 {
            background: #224e5e;
            min-height: 180px;
        }
        .section8-heading {
            margin-top: 1%;
            color: #f78000;
        }
        .button-header-text5 {
            padding-left: 16px;
            margin-top: -6px;
            color: white;
            font-size: 18px;
        }
        .button-text-header5 {
            font-size: 28px;
            margin-top: -1px;
            color: white;
            text-align:center;
        }
        button#clip-div5 {
            background-image: linear-gradient( #F37F00, #FFB767);
            border: #e07900!important;
            height: 60px!important;
            border-radius: 31px;
            margin-top: 2px!important;
            margin-left: -232px;
            width: 363px!important;
            padding-top: 7px;
        }
        
        `}
        </style>
    );
}